import Icon from './Icon';
import { logo } from '../assets/images/images';
import { Link } from 'react-router-dom';
function Footer() {
  return (
    <footer className='px-6 pt-20 2-full text-darkPrimary bg-slate-50'>
      {/* UPPER SECTION */}
      <div className='grid grid-cols-5 gap-8 mb-8'>
        {/* LOGO */}
        <div className='col-start-1 justify-self-center col-span-3 md:col-start-1 md:col-span-1 lg:col-start-1 lg:col-span-1'>
          <img
            src={logo}
            alt='logo'
            className='block h-[7rem] object-contain'
          />
        </div>
        {/* QUICK LINKS */}
        <div className='col-start-4 justify-self-center col-span-3 md:col-start-2 md:col-span-2 lg:col-start-2 lg:col-span-1'>
          <h2 className='font-[500] mb-4 text-lg border-b-2 border-darkPrimary inline-block'>
            Quick Links
          </h2>
          <div className='flex flex-col gap-2 justify-start'>
            <Link className='self-start' to='/'>
              Home
            </Link>
            <Link className='self-start' to='/'>
              Menu
            </Link>
            <Link className='self-start' to='/'>
              Contact Us
            </Link>
          </div>
        </div>
        {/* OTHERS */}
        <div className='col-start-1 justify-self-center col-span-3 md:col-start-4 lg:col-start-3 lg:col-span-1'>
          <h2 className='font-[500] mb-4 text-lg border-b-2 border-darkPrimary inline-block'>
            Others
          </h2>
          <div className='flex flex-col gap-2'>
            <Link className='self-start' to='/'>
              User FAQS
            </Link>
            <Link className='self-start' to='/'>
              Contact Us
            </Link>
            <Link className='self-start' to='/'>
              Legal
            </Link>
            <Link className='self-start' to='/'>
              Privacy Policy
            </Link>
            <Link className='self-start' to='/'>
              Terms and Conditions
            </Link>
          </div>
        </div>
        {/* PRODUCTS */}
        <div className='col-start-4 justify-self-center col-span-3 md:col-start-1 md:col-span-2 lg:col-start-4 lg:col-span-1'>
          <h2 className='font-[500] mb-4 text-lg border-b-2 border-darkPrimary inline-block'>
            Products
          </h2>
          <div className='flex flex-col gap-2'>
            <Link className='self-start' to='/'>
              Send
            </Link>
            <Link className='self-start' to='/'>
              Receive
            </Link>
            <Link className='self-start' to='/'>
              Buy
            </Link>
          </div>
        </div>
        <div className='col-start-1 justify-self-center text-center md:text-left col-span-5 md:col-start-4 md:col-span-2 lg:col-start-5 lg:col-span-1'>
          <h2 className='font-Aclonica text-3xl'>Social Media</h2>
          <h3 className='text-lg mb-4 text-darkPrimary'>
            Be the first one to know about discounts, offers and events
          </h3>
          <div className='flex gap-6 justify-center md:justify-start items-center'>
            <a href='/' className='inline-block'>
              <Icon name='youtube' className='w-5 h-5 fill-darkPrimary' />
            </a>
            <a href='/' className='inline-block'>
              <Icon name='instagram' className='w-5 h-5 fill-darkPrimary' />
            </a>
            <a href='/' className='inline-block'>
              <Icon name='facebook' className='w-5 h-5 fill-darkPrimary' />
            </a>
            <a href='/' className='inline-block'>
              <Icon name='twitter' className='w-5 h-5 fill-darkPrimary' />
            </a>
          </div>
        </div>
      </div>
      {/* LOWER SECTION */}
      <div className='border-t-[1px] py-5 border-darkPrimary'>
        <h2 className='font-[700] text-darkPrimary text-center'>
          Copyright © 2020. All rights reserved.
        </h2>
      </div>
    </footer>
  );
}

export default Footer;
